// src/Utils/helper.js
import axios from "axios";
import { open_api_with_cookies } from "../../Utils/network";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const validatePhoneNumber = (
  number,
  setPhoneNumberError,
  setShowAlert,
  addAlert,
  setcountrycodeISO
) => {
  try {
    const phoneNumber = parsePhoneNumberFromString(number);
    if (phoneNumber && phoneNumber.isValid()) {
      setcountrycodeISO(phoneNumber.country);
      return true;
    } else {
      throw new Error("Invalid phone number");
    }
  } catch (error) {
    setPhoneNumberError(true);
    setShowAlert(true);
    addAlert(
      "Input Error",
      "Please enter a valid phone number before proceeding",
      "error",
      true
    );
    return false;
  }
};

export const validateEmail = (email, setEmailError, setShowAlert, addAlert) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(email)) {
    return true;
  } else {
    setShowAlert(true);
    addAlert(
      "Input Error",
      "Please enter a valid email before proceeding",
      "error",
      true
    );
    setEmailError(true);
    return false;
  }
};

export const handleOTPChange = (e, index, otp, setOtp, inputRefs) => {
  const { value } = e.target;
  if (/^[0-9]$/.test(value) || value === "") {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== "" && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  }
};

export const handleKeyDown = (e, index, otp, inputRefs) => {
  if (e.key === "Backspace" && otp[index] === "" && index > 0) {
    inputRefs.current[index - 1].focus();
  }
};

export const handlePhoneNumberChange = (
  value,
  data,
  setIsdCode,
  setPhoneNumber,
  setPhoneNumberError,
  setPhoneWithCountryCode
) => {
  const isd_code = `${data.country.dialCode}`;
  setIsdCode(isd_code);
  setPhoneNumber(value);
  const phoneWithCountryCode = `+${isd_code}${value}`;
  setPhoneWithCountryCode(phoneWithCountryCode);
  if (value) {
    setPhoneNumberError(false);
  }
};

export const handleEmailChange = (e, setEmail, setEmailError) => {
  if (e.target.name === "email") {
    setEmailError(false);
  }
  setEmail(e.target.value);
};

export const verifyCoupon = async (
  coupon,
  workshop_id,
  sessionpackage_id,
  challenge_id
) => {
  var localData = {};
  if (workshop_id != null) {
    localData = {
      workshop_id: workshop_id ?? 0,
      coupon_code: coupon,
    };
  } else if (sessionpackage_id != null) {
    localData = {
      sessionpackage_id: sessionpackage_id ?? 0,
      coupon_code: coupon,
    };
  } else if (challenge_id != null) {
    localData = {
      challenge_id: challenge_id ?? 0,
      coupon_code: coupon,
    };
  }

  //console.log(localData);
  try {
    const res = await open_api_with_cookies.post(
      `/workshop/coupon/verify/`,
      localData
    );
    //console.log(res);
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      return res?.data;
    } else if (res?.status === 400) {
      return res;
    }
  } catch (error) {
    //console.log("failed to get coupon list");
  }
  return [];
};

const getDiscountAmount = async (
  matchingCoupon,
  workshop_id,
  sessionpackage_id,
  challenge_id,
  isUSD
) => {
  try {
    //console.log("isUSD", isUSD);
    const res = await open_api_with_cookies.get(`/workshop/coupon/discount/`, {
      params: {
        coupon_code: matchingCoupon.id,
        workshop_id: workshop_id,
        sessionpackage_id: sessionpackage_id,
        challenge_id: challenge_id,
        is_usd: isUSD,
      },
    });
    return res?.data?.discount_amount;
  } catch (error) {
    console.log("failed to get discount amount");
  }
};

export const applyCoupon = async (
  coupon,
  workshop_id,
  sessionpackage_id,
  challenge_id,
  sellingPrice,
  mrpPrice,
  setShowAlert,
  addAlert,
  setCouponFound,
  setMatchingCoupon,
  setNewSellingPrice,
  setDiscountAmount,
  setCouponDiscount,
  setCoupon,
  isUSD
) => {
  if (!coupon) {
    setShowAlert(true);
    addAlert("Input Error", "Please enter a valid coupon", "error", true);
    return { success: false }; // Explicit result
  }

  const matchingCoupon = await verifyCoupon(
    coupon,
    workshop_id,
    sessionpackage_id,
    challenge_id
  );
  //console.log("matchingCoupon", matchingCoupon);
  if (matchingCoupon?.status === 400) {
    setShowAlert(true);
    addAlert(
      "Input Error",
      matchingCoupon?.data?.coupon_code[0],
      "error",
      true
    );
    return { success: false };
  }
  if (Array.isArray(matchingCoupon) && matchingCoupon.length === 0) {
    setShowAlert(true);
    addAlert("Input Error", "Invalid Coupon code", "error", true);
    return { success: false };
  }

  if (matchingCoupon) {
    const discount_amt = await getDiscountAmount(
      matchingCoupon,
      workshop_id,
      sessionpackage_id,
      challenge_id,
      isUSD
    );
    setCouponFound(true);
    setMatchingCoupon(matchingCoupon);
    sellingPrice -= discount_amt;
    setNewSellingPrice(sellingPrice.toFixed(2));
    const new_discount_amount = mrpPrice - sellingPrice.toFixed(2);
    setDiscountAmount(new_discount_amount.toFixed(2));
    setCouponDiscount(discount_amt);
    // Clear the coupon input field
    setCoupon("");
    return { success: true, message: "Coupon applied successfully!" };
  } else {
    setCouponFound(false);
    setShowAlert(true);
    addAlert(
      "Not Found",
      "The entered coupon is not applicable",
      "warning",
      true
    );
    return { success: false };
  }
};

export const requestOTP = async (
  phoneNumber,
  isdCode,
  setOtpRequested,
  setShowAlert,
  addAlert,
  email,
  authMethod,
  activeTab
) => {
  let localData = {};
  if (authMethod === "email") {
    localData = {
      email: email,
      auth_method: authMethod,
      auth_type: activeTab,
    };
  } else if (authMethod === "phone") {
    localData = {
      phone: phoneNumber,
      isd_code: isdCode,
      auth_method: authMethod,
      auth_type: activeTab,
    };
  } else {
    localData = {
      phone: phoneNumber,
      isd_code: isdCode,
      email: email,
      auth_method: authMethod,
      auth_type: activeTab,
    };
  }

  try {
    const res = await open_api_with_cookies.post(
      `/auth/login/generate_otp/`,
      localData
    );
    //console.log(res.data);
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      setOtpRequested(true);
      setShowAlert(true);
      if (authMethod === "email") {
        addAlert(
          "OTP Sent",
          `OTP is sent to ${email} and to your registered phone number`,
          "success",
          true
        );
      } else {
        addAlert(
          "OTP Sent",
          `OTP is sent to +${isdCode} ${phoneNumber} and to your registered email`,
          "success",
          true
        );
      }
      return res?.data;
    } else if (res?.status === 400) {
      setShowAlert(true);
      addAlert("Register Error", res?.data?.error, "error", true);
    } else if (res?.status === 403) {
      setShowAlert(true);
      addAlert(
        "Register Error",
        "You have requested too many OTPs. Please try again after an hour",
        "error",
        true
      );
    }
  } catch (err) {
    //console.log(err);
  }
};

export const validateOTP = async (
  otp,
  isdCode,
  phoneNumber,
  authMethod,
  activeTab,
  email,
  setOtpValidated,
  setVerified,
  setUserId,
  setShowAlert,
  addAlert,
  setfirstName,
  setLastName,
  setUserName,
  setEmail,
  setPhoneNumber,
  setIsAuthenticated,
  setIsUserInfoExists,
  setEnablePayButton,
  updateIsUserInfoExists
) => {
  const userInputOtp = otp.join(""); // Combine user-input OTP digits
  let localData = {};
  if (authMethod === "email") {
    localData = {
      email: email,
      otp: Number(userInputOtp),
      auth_method: authMethod,
      auth_type: activeTab,
    };
  } else if (authMethod === "phone") {
    localData = {
      phone: phoneNumber,
      isd_code: isdCode,
      otp: Number(userInputOtp),
      auth_method: authMethod,
      auth_type: activeTab,
    };
  } else {
    localData = {
      phone: phoneNumber,
      isd_code: isdCode,
      email: email,
      otp: Number(userInputOtp),
      auth_method: authMethod,
      auth_type: activeTab,
    };
  }

  try {
    const res = await open_api_with_cookies.post(
      `/auth/login/validate_otp/`,
      localData
    );

    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      if (res?.data?.data?.user != null) {
        setOtpValidated(true);
        const userInfoExists = isUserInfoExists(
          res,
          setfirstName,
          setLastName,
          setEmail,
          setPhoneNumber,
          false
        );
        localStorage.setItem("useEmail", false);
        localStorage.setItem("usePhone", true);
        setIsAuthenticated(true);
        const userDetailsId = res?.data?.data?.user?.id;
        const accessToken = res?.data?.data?.token?.access;
        const userName =
          res?.data?.data?.user?.first_name +
          " " +
          res?.data?.data?.user?.last_name;
        setUserName(userName);
        if (userInfoExists) {
          setVerified(true);
        } else {
          const sessionData = sessionStorage.getItem("expertSession");
          if (sessionData) {
            const expertSessionData = JSON.parse(sessionData);
            postExpertUserLink(expertSessionData.expertslug, accessToken);
          }
        }
        if (userInfoExists) {
          setEnablePayButton(true);
          updateIsUserInfoExists(true);
        } else {
          setEnablePayButton(false);
          updateIsUserInfoExists(false);
        }
        setIsUserInfoExists(userInfoExists);
        setUserId(userDetailsId);
        localStorage.setItem("userName", userName);
        localStorage.setItem("userId", userDetailsId);
      }
      return true;
    } else {
      setShowAlert(true);
      addAlert("OTP Error", res?.data?.data?.message, "error", true);
    }
  } catch (err) {
    //console.log(err);
  }
  return false;
};

const isUserInfoExists = (
  res,
  setFirstName,
  setLastName,
  setEmail,
  setPhoneNumber,
  useEmail
) => {
  let firstName = res?.data?.data?.user?.first_name;
  let lastName = res?.data?.data?.user?.last_name;
  let userEmail = res?.data?.data?.user?.email;
  let userPhone = res?.data?.data?.user?.phone;
  if (firstName) {
    setFirstName(firstName);
  }
  if (lastName) {
    setLastName(lastName);
  }
  if (userEmail) {
    setEmail(userEmail);
  }
  if (userPhone) {
    setPhoneNumber(userPhone);
  }

  if (firstName && lastName && userEmail && userPhone) {
    return true;
  }

  return false;
};

export const checkUserInfoExists = (
  firstName,
  lastName,
  email,
  phone,
  useEmail
) => {
  if (firstName && lastName && email && phone) {
    return true;
  }
  return false;
};

export const addAlert = (
  title,
  message,
  type,
  autoClose = false,
  setAlerts
) => {
  setAlerts((prevAlerts) => [
    ...prevAlerts,
    { id: Date.now(), title, message, autoClose, type },
  ]);
};

export const removeAlert = (id, setAlerts) => {
  setAlerts((prevAlerts) => prevAlerts.filter((alert) => alert.id !== id));
};

export const fetchProfileTypes = async (token, setProfileTypes) => {
  try {
    const res = await open_api_with_cookies.get("/profiles/register/as");
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      const data = await res.data.results;
      setProfileTypes(data);
    }
  } catch (error) {
    console.error("Error fetching profile types:", error);
  }
};

export const handleCouponChange = (event, setCoupon) => {
  setCoupon(event.target.value);
};

export const fetchUserDetails = async () => {
  try {
    const res = await open_api_with_cookies.get(`/profiles/me/`);
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      return res?.data;
    }
  } catch (err) {
    //console.log(err);
  }
};

export const fetchExpertDetails = async (expertSlug) => {
  try {
    const res = await open_api_with_cookies.get(
      `profiles/experts/${expertSlug}/`
    );
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      return res?.data;
    }
  } catch (err) {
    //console.log(err);
  }
};

export const postExpertUserLink = async (expertSlug, bearerToken) => {
  const localData = {
    expert_slug: expertSlug ?? "",
  };
  try {
    const res = await open_api_with_cookies.post(
      `stats/track-login/`,
      localData
    );
  } catch (err) {}
};

export const postExpertUserPurchase = async (
  expertSessionData,
  workshopPurchaseId,
  sessionPurchaseId
) => {
  var localData = {};
  if (workshopPurchaseId != null) {
    localData = {
      expert_slug: expertSessionData.expertslug ?? "",
      workshop_id: workshopPurchaseId,
      page_url: expertSessionData.page_url,
      utm_source: expertSessionData.utm_source,
      utm_medium: expertSessionData.utm_medium,
      utm_campaign: expertSessionData.utm_campaign,
    };
  } else {
    localData = {
      expert_slug: expertSessionData.expertslug ?? "",
      session_id: sessionPurchaseId,
      page_url: expertSessionData.page_url,
      utm_source: expertSessionData.utm_source,
      utm_medium: expertSessionData.utm_medium,
      utm_campaign: expertSessionData.utm_campaign,
    };
  }
  try {
    const res = await open_api_with_cookies.post(
      `stats/track-purchase/`,
      localData
    );
  } catch (err) {}
};

export const getBanners = async (placement) => {
  try {
    const res = await open_api_with_cookies.get(`core/banners/${placement}/`);

    // Check for success status
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      //console.log(res?.data?.results);
      return res?.data?.results;
    }
  } catch (err) {
    console.error("Error fetching banners:", err);
  }
};

export const validateGoogleLoginWithToken = async (
  idToken,
  setOtpValidated,
  setVerified,
  setUserId,
  setShowAlert,
  handleAddAlert,
  setEmail,
  setPhoneNumber,
  setfirstName,
  setLastName,
  setUserName,
  setIsAuthenticated,
  setIsUserInfoExists,
  useEmail,
  setEnablePayButton,
  updateIsUserInfoExists
) => {
  const localData = {
    token: idToken,
  };

  try {
    const res = await open_api_with_cookies.post(
      `/auth/google/oauth/`,
      localData
    );
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      if (res?.data?.user != null) {
        setOtpValidated(true);
        const userInfoExists = isUserInfoExists(
          res,
          setfirstName,
          setLastName,
          setEmail,
          setPhoneNumber,
          true
        );
        localStorage.setItem("useEmail", true);
        localStorage.setItem("usePhone", false);
        const userDetailsId = res?.data?.user?.id;
        const accessToken = res?.data?.token?.access;
        const userName =
          res?.data?.user?.first_name + " " + res?.data?.user?.last_name;
        setUserName(userName);
        if (userInfoExists) {
          setVerified(true);
        } else {
          const sessionData = sessionStorage.getItem("expertSession");
          if (sessionData) {
            const expertSessionData = JSON.parse(sessionData);
            postExpertUserLink(expertSessionData.expertslug, accessToken);
          }
        }
        if (userInfoExists) {
          setEnablePayButton(true);
          updateIsUserInfoExists(true);
        }
        setIsUserInfoExists(userInfoExists);
        setEmail(res?.data?.user?.email);
        setUserId(userDetailsId);
        localStorage.setItem("userName", userName);
        localStorage.setItem("userId", userDetailsId);
        setIsAuthenticated(true);
      }
    } else {
      setShowAlert(true);
      handleAddAlert("Login Error", res?.data?.message, "error", true);
    }
  } catch (err) {
    //console.log(err);
  }
};

export function formatTimeTo12Hour(timeString) {
  const [hours, minutes] = timeString.split(":");

  const hour = parseInt(hours, 10) % 12 || 12;
  const ampm = parseInt(hours, 10) >= 12 ? "PM" : "AM";

  return `${hour}:${minutes} ${ampm}`;
}

export function formatDateToReadable(dateString) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const [year, month, day] = dateString.split("-");

  const monthName = months[parseInt(month, 10) - 1];

  const dayWithSuffix = getDayWithSuffix(parseInt(day, 10));

  return `${dayWithSuffix} ${monthName} ${year}`;
}

function getDayWithSuffix(day) {
  if (day > 3 && day < 21) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
}
